export const pageTitle = (item) => ({
  name: item?.name,
});

export const mutationLabel = (item) => ({
  id: item?.id,
});
